export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyžaduje se potvrzení"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorizaci je třeba potvrdit jednorázovým klíčem"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorizaci je třeba potvrdit kouzelným slovem"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registraci je třeba potvrdit kódem z sms zprávy"])}
}